export function useLastModifiedHead(lastModified?: number | string | null) {
  if (import.meta.client || !lastModified) return;

  useHead({
    meta: [
      {
        key: 'last-modified',
        property: 'last-modified',
        content: String(lastModified),
      },
    ],
  });
}
